/// <reference types="@angular/localize" />

import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { SeoService } from '@mos/client/web/core/seo.service'

@Component({
	selector: 'memory-of-souls-root',
	template: ` <router-outlet></router-outlet> `,
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [],
	imports: [RouterOutlet],
})
export class AppComponent {
	title = 'Memory of Souls'

	constructor() {
		// index.html hardcodes these in French; SeoService sets them per-locale instead so the
		// prerendered output (/, /legal/*) and the client-rendered routes carry no French text
		// in the en build. Per-route <title> overrides (legal pages) still apply on top via the
		// router's own TitleStrategy.
		inject(SeoService).set({
			title: $localize`:@@title.default:Memory of Souls : Visual novel d'amour, de rêves et dons extraordinaires`,
			description: $localize`:@@meta.description:Plongez dans l'univers envoûtant de Memory of Souls, un visual novel captivant où amour et aventure se mêlent. Choisissez vos instants, explorez un monde mystérieux et vivez une romance inoubliable.`,
			ogTitle: $localize`:@@meta.og.title:Memory of Souls | Visual novel d'amour par Nineland`,
		})
	}
}
